import { useRespondentsFromAPI } from "Signups/stateHooks";

export function useIsSignedUpForItem(signupItemID) {
  const respondents = useRespondentsFromAPI(signupItemID);

  return respondents.length > 0;
}
